export const FREQ_A4_MIN = 300;
export const FREQ_A4_MAX = 999;
